import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryEntrySection() {
  return (
    <section className="w-full bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 font-bold">
            游戏分类
          </h2>
          <p className="text-sm text-foreground-500 mt-1">
            按类型浏览你感兴趣的游戏
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-6 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300/60 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <div className="text-center">
                <h3 className="font-heading text-sm text-foreground-800 font-bold whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-400 mt-1">
                  {cat.count} 款游戏
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}